// extracted by mini-css-extract-plugin
export default {"searchPage":"SearchPage_searchPage__tMudc","resultsSection":"SearchPage_resultsSection__sF2FQ","collectionSection":"SearchPage_collectionSection__njx6L"};